import { Component } from '@angular/core';

import { StripeCustomerComponent } from '../../components/stripe-customer/stripe-customer.component';

@Component({
    selector: 'app-customers-page',
    imports: [StripeCustomerComponent],
    templateUrl: './customers-page.component.html',
    styleUrl: './customers-page.component.css'
})
export class CustomersPageComponent {

}
